import { createContext, useContext, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

const DesignContext = createContext()

export function DesignProvider({ children }) {
  const location = useLocation()
  const [isNewDesign, setIsNewDesign] = useState(false)

  useEffect(() => {
    const pathHasNewDesign = location.pathname.includes('/ndg')
    setIsNewDesign(pathHasNewDesign)
  }, [location.pathname])

  return (
    <DesignContext.Provider value={{ isNewDesign }}>
      {children}
    </DesignContext.Provider>
  )
}

export function useDesign() {
  const context = useContext(DesignContext)
  if (context === undefined) {
    throw new Error('useDesign must be used within a DesignProvider')
  }
  return context
}
